var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('banner',{attrs:{"title":_vm.getText('about-title')}}),_c('section',{staticClass:"bg-gray-700"},[_c('workplace-experience')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }